/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { GetAppointmentBaseResponse } from './GetAppointmentBaseResponse';
import {
    GetAppointmentBaseResponseFromJSON,
    GetAppointmentBaseResponseFromJSONTyped,
    GetAppointmentBaseResponseToJSON,
    GetAppointmentBaseResponseToJSONTyped,
} from './GetAppointmentBaseResponse';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { BookingStatus } from './BookingStatus';
import {
    BookingStatusFromJSON,
    BookingStatusFromJSONTyped,
    BookingStatusToJSON,
    BookingStatusToJSONTyped,
} from './BookingStatus';
import type { GetClassRoomResponse } from './GetClassRoomResponse';
import {
    GetClassRoomResponseFromJSON,
    GetClassRoomResponseFromJSONTyped,
    GetClassRoomResponseToJSON,
    GetClassRoomResponseToJSONTyped,
} from './GetClassRoomResponse';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { GetStudentBaseResponse } from './GetStudentBaseResponse';
import {
    GetStudentBaseResponseFromJSON,
    GetStudentBaseResponseFromJSONTyped,
    GetStudentBaseResponseToJSON,
    GetStudentBaseResponseToJSONTyped,
} from './GetStudentBaseResponse';

/**
 * 
 * @export
 * @interface GetAppointmentBookingResponse
 */
export interface GetAppointmentBookingResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetAppointmentBookingResponse
     */
    bookingId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetAppointmentBookingResponse
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetAppointmentBookingResponse
     */
    endTime: Date;
    /**
     * 
     * @type {BookingStatus}
     * @memberof GetAppointmentBookingResponse
     */
    status: BookingStatus;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentBookingResponse
     */
    reason: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAppointmentBookingResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {GetStudentBaseResponse}
     * @memberof GetAppointmentBookingResponse
     */
    student: GetStudentBaseResponse;
    /**
     * 
     * @type {GetClassRoomResponse}
     * @memberof GetAppointmentBookingResponse
     */
    classRoom: GetClassRoomResponse | null;
    /**
     * 
     * @type {GetAppointmentBaseResponse}
     * @memberof GetAppointmentBookingResponse
     */
    appointment: GetAppointmentBaseResponse | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof GetAppointmentBookingResponse
     */
    appointmentVariantId: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAppointmentBookingResponse
     */
    participantCount: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentBookingResponse
     */
    duration: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetAppointmentBookingResponse
     */
    price: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {PriceType}
     * @memberof GetAppointmentBookingResponse
     */
    priceType: PriceType | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAppointmentBookingResponse
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentBookingResponse
     */
    locationName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentBookingResponse
     */
    instructorNotes: string | null;
}



/**
 * Check if a given object implements the GetAppointmentBookingResponse interface.
 */
export function instanceOfGetAppointmentBookingResponse(value: object): value is GetAppointmentBookingResponse {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('classRoom' in value) || value['classRoom'] === undefined) return false;
    if (!('appointment' in value) || value['appointment'] === undefined) return false;
    if (!('appointmentVariantId' in value) || value['appointmentVariantId'] === undefined) return false;
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('instructorNotes' in value) || value['instructorNotes'] === undefined) return false;
    return true;
}

export function GetAppointmentBookingResponseFromJSON(json: any): GetAppointmentBookingResponse {
    return GetAppointmentBookingResponseFromJSONTyped(json, false);
}

export function GetAppointmentBookingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentBookingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['bookingId']),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'status': BookingStatusFromJSON(json['status']),
        'reason': json['reason'],
        'createdAt': (new Date(json['createdAt'])),
        'student': GetStudentBaseResponseFromJSON(json['student']),
        'classRoom': GetClassRoomResponseFromJSON(json['classRoom']),
        'appointment': GetAppointmentBaseResponseFromJSON(json['appointment']),
        'appointmentVariantId': AppointmentRequestVariantIdFromJSON(json['appointmentVariantId']),
        'participantCount': ActorActivityRecordActorUserIdFromJSON(json['participantCount']),
        'duration': json['duration'],
        'price': BalanceUnitStatementEntryDebitFromJSON(json['price']),
        'priceType': PriceTypeFromJSON(json['priceType']),
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'locationName': json['locationName'],
        'instructorNotes': json['instructorNotes'],
    };
}

export function GetAppointmentBookingResponseToJSON(json: any): GetAppointmentBookingResponse {
    return GetAppointmentBookingResponseToJSONTyped(json, false);
}

export function GetAppointmentBookingResponseToJSONTyped(value?: GetAppointmentBookingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bookingId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['bookingId']),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'].toISOString(),
        'status': BookingStatusToJSON(value['status']),
        'reason': value['reason'],
        'createdAt': value['createdAt'].toISOString(),
        'student': GetStudentBaseResponseToJSON(value['student']),
        'classRoom': GetClassRoomResponseToJSON(value['classRoom']),
        'appointment': GetAppointmentBaseResponseToJSON(value['appointment']),
        'appointmentVariantId': AppointmentRequestVariantIdToJSON(value['appointmentVariantId']),
        'participantCount': ActorActivityRecordActorUserIdToJSON(value['participantCount']),
        'duration': value['duration'],
        'price': BalanceUnitStatementEntryDebitToJSON(value['price']),
        'priceType': PriceTypeToJSON(value['priceType']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'locationName': value['locationName'],
        'instructorNotes': value['instructorNotes'],
    };
}

